import { whenBrowserQueryPersistenceReady } from "~/lib/query-persistence";
import type { AppRouterContext } from "~/lib/router-runtime";
import { settleRoutePreloads } from "~/lib/router-preload";
import { isServerRendering, isSnapshotRendering } from "~/lib/ssr/runtime";
import { getDirectIndexCatalogQueryOptions } from "./data/direct-index-queries";

export async function preloadBuildRoute(
  context: AppRouterContext,
): Promise<void> {
  // Prepared documents and static fallback shells never call the origin.
  if (isSnapshotRendering()) return;
  if (!isServerRendering()) {
    await new Promise<void>((resolve) => {
      const timeoutId = setTimeout(resolve, 50);
      void whenBrowserQueryPersistenceReady().then(() => {
        clearTimeout(timeoutId);
        resolve();
      });
    });
  }
  // A failed catalog read leaves the chooser's retry UI usable.
  await settleRoutePreloads([
    context.queryClient.ensureQueryData(
      getDirectIndexCatalogQueryOptions({ platformApi: context.platformApi }),
    ),
  ]);
}
